import { subjectColors, mySubjectColors } from '../consts/subject';
import { IRecomendVideo, VideoCard } from '../model/home';
import { IChatMessage, Subject } from '../model/video';
import { isSameDay } from './DateUtils';

export function getSubjectByVideo(
  video: VideoCard,
): [Subject, { bg: string; text: string; border: string }] {
  const subject = video.subject || 'Others';
  const subjectColor = subjectColors[subject]
    ? subjectColors[subject]
    : subjectColors['Others'];
  return [subject, subjectColor];
}
export function getMySubjectByVideo(
  video: VideoCard,
): [Subject, { bg: string; text: string; border: string }] {
  const subject = video.subject || 'Others';
  const subjectColor = mySubjectColors[subject]
    ? mySubjectColors[subject]
    : mySubjectColors['Others'];
  return [subject, subjectColor];
}

export function addSystemTimeInMsgList(_msgs: IChatMessage[]): IChatMessage[] {
  const msglistRes: IChatMessage[] = [];
  const noTimeList = _msgs.filter((item) => item.role !== 'system');
  let lastTime = new Date(1900, 1, 1);
  for (let i = 0; i < noTimeList.length; i++) {
    //
    if (!isSameDay(_msgs[i].timestamp, lastTime)) {
      lastTime = _msgs[i].timestamp;
      msglistRes.push({
        role: 'system',
        timestamp: lastTime,
        content: [''],
      });
    }
    msglistRes.push(_msgs[i]);
  }
  return msglistRes;
}
export const formatDuration = (_seconds: number) => {
  const seconds = Math.floor(_seconds);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// 判断视频已经生成成功
export const isVideoGenerateSucceeded = (video: VideoCard) => {
  return video.status === 'v_succ'
};

export const isNewTagVideoCard = (video: VideoCard) => {
  // 判断视频是否在24小时内创建
  const now = Date.now();
  const created = (video.create_ts || 0) * 1000;
  const twentyFourHours = 24 * 60 * 60 * 1000;
  const isIn24Hour = now - created < twentyFourHours;

  // 如果是自己的 && 24小时内创建的 && play_count === 0 的就是newtag
  return video.is_owner && video.play_count === 0 && isIn24Hour && isVideoGenerateSucceeded(video);
};

export const getGeneratingProgress = (video: VideoCard) => {
  const elapsed = Math.floor(
    (Date.now() - (video.create_ts || 0) * 1000) / 1000,
  );
  const totalSeconds = 10 * 60;
  const progressPercent = Math.min(
    Math.floor((elapsed / totalSeconds) * 90),
    90,
  );
  return progressPercent;
};

export function videoCardToCommon(video: VideoCard): IRecomendVideo {
  return {
    id: video.video_id,
    question: video.title,
    subject: video.subject || 'Others',
    views: '0',
    likes: 0,
    cover_img: video.cover_img,
    createdAt: new Date(video.create_ts * 1000),
    video_url: video.video_url,
    video_duration: video.video_duration ?? 0,
  };
}
